module.exports = __webpack_public_path__ + "assets/img/onboarding_1.d39888b5.png";